import { useEffect, useRef, useState } from "react";
import { NavLink, } from "react-router-dom";
import FooterLogo from "../components/FooterLogo";
import FormObserver from "../components/FormElements/FormObserver";
import { Form, Formik } from "formik";
import { object, string } from "yup";
import { FormInput } from "../components/FormElements";
import { Button } from "../components/Elements";
import ReCAPTCHA from "react-google-recaptcha";
import commonNetwork from "../../common/api/commonNetwork";
import { toast } from "react-toastify";
import { AUTH_TOKEN, IS_BANK_USER, IS_SABEEAPP, USER_ID, USER_IDENTITY, USER_NAME_SURNAME, USER_PERMISSIONS } from "../../constants/storageKeys";
import { useNavigate } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCreditCard } from "@fortawesome/free-solid-svg-icons";
import { getNavigationUrl } from "../../common/helpers/navigationHelpers";
import { useRecoilValue } from "recoil";
import { tenantState } from "../../store/recoil/tenant/atoms";
import { encryptAES } from "../../common/helpers/encryptonHelper";
import PageTitle from "../components/PageTitle";
import { pageTitleTexts } from "../../constants/texts/pageTitleTexts";
import { ThunkDispatch } from "redux-thunk";
import { useDispatch } from "react-redux";
import { getReactAppParameters } from "../../store/slices/reactAppParameterSlices";

type FormProps = {
    userName: string,
    password: string,
    firmCode: string
}

const LoginPage = () => {

    const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
    const { firmInformations } = useRecoilValue(tenantState);
    const navigate = useNavigate()


    const [loginLoading, setLoginLoading] = useState(false);
    const recaptchaRef = useRef<any>();
    const [capthaLoad, setCapthaLoad] = useState(false);

    const isRequireFirmCode = firmInformations.firmCode === "ORTAKODEME";

    useEffect(() => {
        setTimeout(() => {
            setCapthaLoad(true);
        }, 500);
    }, []);


    const onSubmit = async (values: FormProps) => {


        setLoginLoading(true);
        let token = "";
        try {
            token = await recaptchaRef.current.executeAsync();
        } catch (error) {

        }
        const params = {
            firmcode: values.firmCode,
            username: values.userName,
            password: values.password,
            token: token
        }

        const result = await commonNetwork.post("/token/login-from-web-v1", params);
        const { isSuccess } = result;

        setLoginLoading(false);
        if (isSuccess) {

            const { isSuccess, message } = result.data;
            if (isSuccess) {

                localStorage.setItem(AUTH_TOKEN, result.data.token);
                localStorage.setItem(USER_ID, result.data.user);

                let userIdentity = encryptAES(result.data.useridentity);
                let permissions = result.data.operationarray;
                let permissionshash = encryptAES(permissions);

                localStorage.setItem(USER_IDENTITY, userIdentity);
                localStorage.setItem(USER_PERMISSIONS, permissionshash);
                localStorage.setItem(IS_BANK_USER, result.data.isbankuser + "");
                localStorage.setItem(IS_SABEEAPP, result.data.issabeeapp + "");
                localStorage.setItem(USER_NAME_SURNAME, result.data.namesurname + "");

                try {
                    // Parametrelerin çekilip Redux'a yazılmasını zorunlu olarak bekle
                    await dispatch(getReactAppParameters()).unwrap();
                } catch (paramError) {
                    console.error("Parametreler yüklenirken hata oluştu:", paramError);
                    toast.error("Uygulama parametreleri alınamadı.");
                }

                if (result.data.isbankuser) {
                    navigate("/" + firmInformations.firmPath + "/odeme-sayfasi");
                } else {
                    navigate("/" + firmInformations.firmPath + "/dashboard");
                }

            } else {
                toast.error(message);
            }
        } else {
            toast.error(result.errorMessage);
        }
    }

    const goToPublicPayment = () => {
        navigate("/" + firmInformations.firmPath + "/uyeliksiz-odeme");
    }
    const initialValues = {
        userName: "",
        password: "",
        firmCode: firmInformations.firmCode
    }
    let firmValidation = {}
    if (isRequireFirmCode) {
        firmValidation = {
            firmCode: string().required("Lütfen Firma Kodunu giriniz."),
        }
    }
    const filtersSchema = object({
        userName: string().required("Lütfen Kullanıcı adını giriniz."),
        password: string().required("Lütfen şifreyi giriniz."),
        ...firmValidation
    });



    return (
        <div className="flex flex-col md:flex-row h-screen items-center">

            <PageTitle showFirmInformation={true} title={pageTitleTexts.loginPage} />
            <div className="lg:block w-full md:w-1/2 xl:w-2/3 h-screen">
                <img src="/images/logopng.svg" className="w-full h-full object-cover" alt="Sample image" />
            </div>
            <div className="w-full md:w-1/3 right-side mb-4">


                <div className="max-[33%]">
                </div>
                <div className="px-6 lg:px-12 xl:px-10 text-center md:text-right justify-center md:justify-end">
                    <div className="text-center mb-8">
                        <img className="mx-auto w-48" src={`https://tahsilat.elogo.com.tr/etahsilatapitest/Uploads/firm_logos/${firmInformations.logoPath}`} alt="logo" />

                    </div>

                    <div className="flex flex-row items-center justify-center lg:justify-center m-b-10">
                        <h1 className="text-2xl font-semibold  mb-0 text-center text-black">{firmInformations.firmName}</h1>
                    </div>


                    <div className="flex flex-row items-center justify-center lg:justify-center mb-8 ">
                        <p className="text-lg font-normal mb-0 text-center">Sisteme giriş yapabilmek için bilgilerinizi giriniz</p>
                    </div>
                    <div className="flex items-center my-4 before:flex-1 before:border-t before:border-gray-300 before:mt-0.5 after:flex-1 after:border-t after:border-gray-300 after:mt-0.5">
                        <p className="text-center font-semibold mx-4 mb-0">Firma Girişi</p>
                    </div>
                    <div className="mb-8">

                        <Formik
                            validationSchema={filtersSchema}
                            enableReinitialize
                            onSubmit={onSubmit}

                            initialValues={initialValues}
                        >
                            {formProps => (
                                <Form>
                                    <FormObserver watch={() => {

                                    }} />
                                    <div className="flex flex-col sm:text-left lg:text-center justify-start mt-3">
                                        <input type="hidden" name="CaptchaToken" id="CaptchaToken" value="" />


                                        {isRequireFirmCode ? (
                                            <div className=" mt-3">
                                                <div>
                                                    <div className="w-full relative">
                                                        <FormInput
                                                            label="Firma Kodu*"
                                                            name="firmCode"
                                                            type="text"
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                        ) : (
                                            <div className="hidden">
                                                <FormInput
                                                    label="Firma Kodu*"
                                                    name="firmCode"
                                                    type="hidden"

                                                    value={firmInformations.firmCode}
                                                />
                                            </div>
                                        )}
                                        <div className=" mt-3">
                                            <div>
                                                <div className="w-full relative">
                                                    <FormInput
                                                        label="Kullanıcı Adı*"
                                                        name="userName"
                                                        type="text"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="mt-3">
                                            <div>
                                                <div className="w-full relative">
                                                    <FormInput
                                                        label="Şifre*"
                                                        name="password"
                                                        type="password"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className=" mt-4 flex justify-end">
                                            <NavLink className="flex flex-row  not-italic  text-sm leading-5 font-semibold font-nunito text-primary"
                                                to={getNavigationUrl("/sifremi-unuttum/")}  >
                                                <a className="not-italic  text-sm leading-5 font-semibold font-nunito text-primary"
                                                    target={"_blank"} >
                                                    Şifremi Unuttum
                                                </a>
                                            </NavLink>
                                        </div>


                                    </div>

                                    <div className="text-center lg:text-center mb-4">



                                        <Button
                                            type="submit"
                                            color="primary"
                                            hover="primary"
                                            className={"w-full h-12 mt-6 px-7 py-3"}
                                            size="xl"
                                            disabled={loginLoading}
                                            loading={loginLoading}
                                        >
                                            <span className="font-bold text-base">Giriş Yap</span>
                                        </Button>


                                        {firmInformations.isPublicPayment && (
                                            <Button
                                                type="button"
                                                color="gray"
                                                hover="gray"
                                                className={" w-full h-12 mt-6 px-7 py-3"}
                                                size="xl"
                                                disabled={loginLoading}
                                                callback={goToPublicPayment}

                                            >
                                                <div className="flex items-center">
                                                    <FontAwesomeIcon icon={faCreditCard} className="mr-3" size="xl" />
                                                    <span className="text-lg uppercase  ">
                                                        Üyeliksiz Ödeme Yap
                                                    </span>

                                                </div>

                                            </Button>
                                        )}

                                    </div>

                                </Form>
                            )}
                        </Formik>

                    </div>
                </div>
                {capthaLoad && (
                    <ReCAPTCHA
                        ref={recaptchaRef}
                        size="invisible"
                        sitekey="6LewgCwmAAAAAD6pjQQbOP9Dxq7AC025wgOuNZDb"
                    />
                )}


                <div
                    className="flex items-endflex items-end justify-center "

                >
                    <FooterLogo />
                </div>
            </div>

        </div>
    );
}
export default LoginPage;